module.exports = __webpack_public_path__ + "2f29f30a50bfb2750828a28184be1a41.svg";